export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_15.eb0cb601.png";